import styled from 'styled-components'
import mediaQueries from 'components/media-queries'
import circlesLoader from 'assets/loader-resultados-circulos.gif'
import React from 'react'
import { useTranslation } from 'react-i18next'

const CirclesLoader = styled.img.attrs(() => ({
  src: circlesLoader,
  alt: 'Loading...'
}))`
  height: 100px;

  ${mediaQueries.tablet`
      margin-bottom: 15px;
    `};
`

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;

  ${mediaQueries.mobile`
    align-items: flex-start;
  `};
`

const Image = styled.img`
  src: ${({ src }) => src};
  align-items: flex-start;
`
const Info = styled.div`
  padding: 40px 20px 0;

  ${mediaQueries.mobile`
    padding: 0 20px;
  `};
`
const Title = styled.label`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.blue};
  font-size: 20px;
`
const Subtitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.gray};
  font-size: 14px;
`

const WaitingForResultLoader = ({ title, subtitle, image }) => {
  const { t } = useTranslation()
  return (
    <Container>
      <Image src={image} />
      <Info>
        <Title>{t(title)}</Title>
        <Subtitle>{t(subtitle)}</Subtitle>
        <CirclesLoader />
      </Info>
    </Container>
  )
}

export default WaitingForResultLoader
